import axios from 'axios';
import RedisInfo from './RedisInfo';

const apiUrl = process.env.REACT_APP_API_URL;

const serviceStatusDetails = async (serviceName) => {
  try {
    const responseRedisData = await RedisInfo.redisDetails();

    const parentGroup = responseRedisData.ParentGroup;
    const dealerMapCode = responseRedisData.DealerMapCode;
    const locCode = responseRedisData.LocCode;
    const token = sessionStorage.getItem('token');

    console.log("serviceName before API call:", serviceName);
    console.log("Redis Data:", { parentGroup, dealerMapCode, locCode, token });
    
    // Prepend SERVICE# if not already present
    const serviceParam = serviceName?.replace(/^SERVICE#/, '');

    const API_URL = `${apiUrl}/api/v1/planUsageDetails/getServiceBalanceDataForDealer/${parentGroup}/${dealerMapCode}/${locCode}/${serviceParam}`;

    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching service details:", error);
    throw error;
  }
};

export default { serviceStatusDetails };
